let preloaderHidden = false;
const startTime = Date.now();
const minDisplayTime = 1000; // Minimum 1 seconds

function hidePreloader() {
  if (preloaderHidden) return;
  
  const elapsedTime = Date.now() - startTime;
  const remainingTime = Math.max(0, minDisplayTime - elapsedTime);
  
  setTimeout(function() {
    preloaderHidden = true;
    const preloader = document.getElementById('preloader');
    preloader.style.opacity = '0';
    setTimeout(function () {
      preloader.style.display = 'none';
    }, 500);
  }, remainingTime);
}

document.addEventListener('DOMContentLoaded', hidePreloader);